import React from 'react';

export function ArtworkImage({ item, className = '', loading = 'lazy' }) {
    const src = item.image_b64 || item.image_url;
    return (
        <img
            src={src}
            alt={item.title ? `${item.title} — ${item.medium || 'Portrait'} by Leiha Martin` : 'Portrait by Leiha Martin'}
            className={className}
            loading={loading}
        />
    );
}
